<span class="back" *ngIf="!disabled" (click)="handleBack()" [inlineSVG]="'/icons/icon-arrow.svg'"></span>
<div class="progress-bar">
  <div class="progress" #progress></div>
</div>
